import React from 'react';
import { Box, Skeleton } from '@mui/material';

const GolfSkeleton = () => {
  return (
    <Box
      sx={{
        width: '160px',
        height: '164px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.16)',
        p: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        border: '1px solid #FFFFFF',
      }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Skeleton variant="text" width={60} height={24} />
      </Box>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '4px', justifyContent: 'center', alignItems: 'center' }}>
        <Skeleton variant="text" width={100} height={16} />
        <Skeleton variant="text" width={120} height={20} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mt: 'auto' }}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '999px' }} />
      </Box>
    </Box>
  );
};

export default GolfSkeleton;
